import _ from 'lodash';
import { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useFormContext } from 'react-hook-form';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const propTypes = {
  action: PropTypes.string,
  isHideCancel: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};

const defaultProps = { action: '' };

const ACTIONS = {
  update: { label: 'Modify to market', value: 'update', isShown: !ApplicationDomainUtility.isLimitOrderOnlyAllowedPartner },
  cancel: { label: 'Cancel', value: 'cancel', isShown: true }
};

const ActionTypeSelector = ({ action: propsAction, isHideCancel, onChange }) => {
  const modifyOrderActionTypeBtnName = useMemo(() => _.uniqueId('modifyOrderActionType-'), []);
  const { errors, register, clearErrors } = useFormContext();
  const validatorConfig = {
    validate: (value) => {
      return (!value ? 'value required' : null);
    }
  };

  const validatorProps = { ref: register(validatorConfig) };

  const availableActions = useMemo(
    () => _.filter(ACTIONS, { isShown: true }).filter(
      (option) => !(isHideCancel && option.value === 'cancel')
    ),
    [isHideCancel]
  );

  const isSingleSelected = availableActions.length === 1 && propsAction === availableActions[0].value && ApplicationDomainUtility?.isLimitOrderOnlyAllowedPartner;

  const actionTypeStyle = classNames(
    'modify-order-selector',
    'align-items-center',
    'gap-5',
    'd-flex',
    'selector-radio-btn',
    { 'visually-hidden': isSingleSelected }
  );

  useEffect(() => {
    if (availableActions.length === 1 && propsAction !== availableActions[0].value) {
      onChange(availableActions[0].value);
    }
  }, [availableActions, propsAction]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    return () => clearErrors(modifyOrderActionTypeBtnName);
  }, [clearErrors, modifyOrderActionTypeBtnName]);

  const inputClassName = classNames('form-check-input', {
    'is-invalid': !!errors[modifyOrderActionTypeBtnName]
  });

  const renderRadioBtn = (optionType) => {
    if (isSingleSelected || (isHideCancel && optionType.value === 'cancel')) return null;

    return (
      <div className="form-check form-check-sm" key={optionType.value}>
        <input
          {...validatorProps}
          className={inputClassName}
          type="radio"
          name={modifyOrderActionTypeBtnName}
          id={`${modifyOrderActionTypeBtnName}-${optionType.value}`}
          value={optionType.value}
          tabIndex="-100"
          checked={optionType.value === propsAction}
          onChange={(e) => onChange(e.target.value)}
        />
        <label className="form-check-label" htmlFor={`${modifyOrderActionTypeBtnName}-${optionType.value}`}>
          <span>
            {_.startCase(optionType.label)}
          </span>
        </label>
      </div>
    );
  };

  return (
    <div className={actionTypeStyle}>
      {_.map(_.filter(availableActions, { isShown: true }), renderRadioBtn)}
    </div>
  );
};

ActionTypeSelector.propTypes = propTypes;
ActionTypeSelector.defaultProps = defaultProps;

export default ActionTypeSelector;
